var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRepostIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6096_21315",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6096_21315)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.15383 18.5001L2.5 14.8463L3.55383 13.7617L5.40385 15.6117V8.18282C5.40385 7.16617 5.76186 6.29982 6.47787 5.58379C7.19391 4.86777 8.06025 4.50977 9.0769 4.50977C10.0936 4.50977 10.9599 4.86777 11.6759 5.58379C12.3919 6.29982 12.75 7.16617 12.75 8.18282V14.827C12.75 15.4283 12.9618 15.9408 13.3855 16.3645C13.8093 16.7883 14.3218 17.0001 14.923 17.0001C15.5243 17.0001 16.0368 16.7883 16.4606 16.3645C16.8843 15.9408 17.0961 15.4283 17.0961 14.827V7.39817L15.2461 9.24817L14.1923 8.16359L17.8461 4.50977L21.5 8.16359L20.4461 9.24817L18.5961 7.39817V14.827C18.5961 15.8437 18.2381 16.71 17.5221 17.426C16.806 18.1421 15.9397 18.5001 14.923 18.5001C13.9064 18.5001 13.04 18.1421 12.324 17.426C11.608 16.71 11.25 15.8437 11.25 14.827V8.18282C11.25 7.58153 11.0381 7.06903 10.6144 6.64532C10.1907 6.2216 9.67818 6.00974 9.0769 6.00974C8.47562 6.00974 7.96312 6.2216 7.5394 6.64532C7.11568 7.06903 6.90382 7.58153 6.90382 8.18282V15.6117L8.75383 13.7617L9.80765 14.8463L6.15383 18.5001Z",
    fill: "#616161"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepostIcon);
export default __webpack_public_path__ + "static/media/repostIcon.67051a675a6caf706d171c1409167f27.svg";
export { ForwardRef as ReactComponent };